import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { PropertyService } from '@app/_components/property';
import { VrboService } from '@app/_services/vrbo.service';

@Component({
    selector: 'app-vrbo-reservation',
    templateUrl: './vrbo-reservation.component.html',
    styleUrls: ['./vrbo-reservation.component.css'],
    standalone: false
})
export class VRBOReservationComponent implements OnInit {
  form1!: UntypedFormGroup;
  formLoading = false;
  shortTermRentals: any[] = [];

  validationMessages = {
    shortTermRentalId: [{ type: 'required', message: 'Property is required' }]
  };

  constructor(
    private formBuilder: UntypedFormBuilder,
    private messageService: MessageService,
    private propertyService: PropertyService,
    private vrboService: VrboService
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.loadShortTermRentals();
  }

  buildForm(): void {
    this.form1 = this.formBuilder.group({
      shortTermRentalId: [null, Validators.required]
    });
  }

  loadShortTermRentals(): void {
    try {
      this.propertyService.findAllSummary()
        .subscribe(
          (res: any) => {
            this.shortTermRentals = res?.data?.properties || [];
          },
          (err: any) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.message || 'Failed to load properties' });
          });
    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: '' + error });
    }
  }

  onSyncLOS(): void {
    if (this.form1.invalid) {
      this.form1.markAllAsTouched();
      return;
    }
    const id = Number(this.form1.value.shortTermRentalId);
    this.formLoading = true;
    this.vrboService.syncLodgingRateLosUpdate(id)
      .subscribe(
        (res: string) => {
          this.formLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'LOS sync completed successfully', sticky: false });
        },
        (err: any) => {
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'We were unable to sync LOS: ' + (err?.message || err), sticky: true });
        });
  }
}


